import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

// Interface for the combined experiment data
export interface ExperimentResultsData {
  finalPeriod1Start: Date | null;
  finalPeriod1End: Date | null;
  finalPeriod2Start: Date | null;
  finalPeriod2End: Date | null;
  grossProfitPeriod1: number | null;
  grossProfitPeriod2: number | null;
  note: string | null;
  generatorUrl: string | null;
}

// Helper to convert Excel serial date to JS Date
const excelDateToJSDate = (serial: number | string | null | undefined): Date | null => {
  if (serial === null || serial === undefined) return null;
  const num = typeof serial === 'string' ? parseFloat(serial) : serial;
  if (typeof num !== 'number' || isNaN(num)) return null;
  const date = new Date((num - 25569) * 86400 * 1000);
  date.setDate(date.getDate() + 1); // Add 1 day to fix Excel offset
  return date;
};

export const getExperimentResultsData = async (
  companyName: string,
  asin: string
): Promise<ExperimentResultsData | null> => {
  try {
    const expDocRef = doc(db, 'pmt2_experiment_results', companyName, 'entries', asin);
    const noteDocRef = doc(db, 'pmt2_data', companyName, 'products', asin);
    const urlDocRef = doc(db, 'pmt2_clienturldatabase', companyName, 'items', '85_BeforeandAfterExperimentTool');

    const [expSnap, noteSnap, urlSnap] = await Promise.all([
      getDoc(expDocRef),
      getDoc(noteDocRef),
      getDoc(urlDocRef),
    ]);

    const expData = expSnap.exists() ? expSnap.data() : {};
    const noteData = noteSnap.exists() ? noteSnap.data() : {};
    const urlData = urlSnap.exists() ? urlSnap.data() : {};

    return {
      finalPeriod1Start: excelDateToJSDate(expData.finalPeriod1Start),
      finalPeriod1End: excelDateToJSDate(expData.finalPeriod1End),
      finalPeriod2Start: excelDateToJSDate(expData.finalPeriod2Start),
      finalPeriod2End: excelDateToJSDate(expData.finalPeriod2End),
      grossProfitPeriod1: typeof expData.grossProfitPeriod1 === 'number' ? expData.grossProfitPeriod1 : null,
      grossProfitPeriod2: typeof expData.grossProfitPeriod2 === 'number' ? expData.grossProfitPeriod2 : null,
      note: typeof noteData['Experiment Note'] === 'string' ? noteData['Experiment Note'] : null,
      generatorUrl: typeof urlData.value === 'string' ? urlData.value : null,
    };
  } catch (error) {
    console.error('[pmt2ExperimentResultsService] Error fetching experiment results:', error);
    return null;
  }
};